export function createFilterToQuery(searchFields = []) {
    const fields = Object.fromEntries((Array.isArray(searchFields) ? searchFields : []).map(field => [field, true]));

    return searchText => ({
        search: {
            value: searchText,
            fields,
        },
    });
}

export const contractorFilterToQuery = createFilterToQuery(['name']);

export const groupFilterToQuery = createFilterToQuery(['name']);

export const extendedCollectionPointFilterToQuery = createFilterToQuery(['customId', 'address.city', 'address.address', 'address.postalCode']);

export const collectionPointFilterToQuery = createFilterToQuery(['customId']);

export const deviceFilterToQuery = createFilterToQuery(['serialNumber']);

export const softwareFilterToQuery = createFilterToQuery(['version']);

export const aliasFilterToQuery = createFilterToQuery(['name', 'software.version']);

export const serviceCompanyFilterToQuery = createFilterToQuery(['name']);

export const userFilterToQuery = createFilterToQuery(['firstName', 'lastName']);

export const promptModelFilterToQuery = createFilterToQuery(['name']);

export const billOfMaterialsModuleFilterToQuery = createFilterToQuery(['name']);

export const deviceModelFilterToQuery = createFilterToQuery(['name', 'code']);
